export default "__VITE_ASSET__Bk52P4jv__"